import api from "@/lib/api";

interface ErrorReport {
  message: string;
  stack?: string;
  componentStack?: string;
  url?: string;
  errorType?: "boundary" | "route" | "unhandled";
}

export async function reportError(error: Error, context?: Omit<ErrorReport, "message" | "stack" | "url">): Promise<void> {
  try {
    const report: ErrorReport = {
      message: error.message,
      stack: error.stack,
      url: window.location.href,
      ...context,
    };
    await api.post("/telemetry/error", report);
  } catch {
    // Never let error reporting crash the app
  }
}
